import { IonContent, IonPage } from "@ionic/react";

import Header from "src/components/Header";
import PerfilPanel from "src/components/PerfilPanel";

interface MiPerfilProps {
  cerrarSesion: () => void;
}

const MiPerfil: React.FC<MiPerfilProps> = ({ cerrarSesion }) => {
  return (
    <IonPage>
      <Header titulo="Mi Perfil" />
      <IonContent id="mi-perfil">
        <PerfilPanel cerrarSesion={cerrarSesion} />
      </IonContent>
    </IonPage>
  );
};

export default MiPerfil;
